module.exports = __webpack_public_path__ + "static/media/06_no_corresponding_point.4cd7728d.png";